import { useTranslation } from '../../../lib/i18n';
import { docSource } from '../../../lib/doc-viewer';
import { ScrollArea, Typography } from '../ui';
import styles from './DocViewerModal.module.css';

// An image artifact, rendered plain — no size cap (unlike markdown/html, an <img> doesn't lay out an
// unbounded DOM tree, so the 2 MB doc-preview cap doesn't apply here). The source is resolved directly
// from `docSource`, never through `useDocText`/`inlineDocTooLarge` — those are markdown/html-only, and
// there is no such thing as inline image bytes on web (see `docSource`'s own note: local bytes are
// native-only).
export function ImageDocView({ content, fileName }: { content?: string | null; fileName: string }) {
  const { t } = useTranslation();
  const source = docSource(content);
  const url = source?.kind === 'remote' ? source.url : null;

  if (!url) {
    return (
      <div className={styles.state}>
        <Typography variant="p2" color="secondary" component="p">
          {t('docViewer.imageUnavailable')}
        </Typography>
      </div>
    );
  }

  return (
    <ScrollArea className={styles.mediaBody}>
      <img src={url} alt={fileName} className={styles.mediaImage} />
    </ScrollArea>
  );
}
